module.exports = __webpack_public_path__ + "static/media/card.d8000746.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/card.png
// module id = 1164
// module chunks = 0